import { render, staticRenderFns } from "./AmsHandwareProducts.vue?vue&type=template&id=70a73a35"
import script from "./AmsHandwareProducts.vue?vue&type=script&lang=js"
export * from "./AmsHandwareProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports